import CharterRateSummary from './CharterRateSummary';

export default CharterRateSummary;
